"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareUTMParameters = exports.extractUTMParameters = exports.UTM_PARAMS_COOKIE_NAME = void 0;
var capitalizedFirst = function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
exports.UTM_PARAMS_COOKIE_NAME = 'cvt_utm_params';
/**
 * Extracts UTM parameters from the URL. Fallback to reading from a cookie
 * @param url
 * @returns
 */
var extractUTMParameters = function (url) {
    var _a;
    var result = {};
    try {
        var urlObj = new URL(url);
        var UTM_PREFIX_1 = 'utm_';
        urlObj.searchParams.forEach(function (value, sParam) {
            if (sParam.startsWith(UTM_PREFIX_1)) {
                var utmParam = sParam.substring(UTM_PREFIX_1.length);
                // utm_campaign represents the name
                if (utmParam === 'campaign') {
                    utmParam = 'name';
                }
                result["utm".concat(capitalizedFirst(utmParam))] = value;
            }
        });
        if (Object.keys(result).length === 0) {
            throw new Error('No utm parameters found in the URL');
        }
    }
    catch (_) {
        if (typeof document === 'undefined') {
            return {};
        }
        // We did not find the utm parameters in the URL, try to read from the cookie
        var cookieValue = (_a = document.cookie) === null || _a === void 0 ? void 0 : _a.split('; ').find(function (row) { return row.startsWith("".concat(exports.UTM_PARAMS_COOKIE_NAME, "=")); });
        var utmParams = cookieValue === null || cookieValue === void 0 ? void 0 : cookieValue.split('=')[1];
        var result_1 = utmParams ? JSON.parse(utmParams) : {};
        return result_1;
    }
    return result;
};
exports.extractUTMParameters = extractUTMParameters;
/**
 * Saves the UTM parameters in a cookie to share them with other apps
 * @param utmParams
 */
var shareUTMParameters = function (utmParams) {
    var _a;
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        var hostname = (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname;
        var domain = hostname === 'localhost' ? 'localhost' : ".".concat(hostname === null || hostname === void 0 ? void 0 : hostname.split('.').reverse()[1], ".").concat(hostname === null || hostname === void 0 ? void 0 : hostname.split('.').pop());
        // Save them in the cookie to share with other apps
        document.cookie = "".concat(exports.UTM_PARAMS_COOKIE_NAME, "=").concat(JSON.stringify(utmParams), ";path=/;domain=").concat(domain);
    }
};
exports.shareUTMParameters = shareUTMParameters;
